function t(t){const o=Object.getPrototypeOf(t.prototype),r=o?.constructor;return r}export{t as getBaseType};
//# sourceMappingURL=index.js.map
